import { Disclaimer, Div, H5, Separator } from '@vgrubs/components';

export const KeyValueInfo = ({
  k,
  v,
  component,
  last = false,
}: {
  k: string;
  v: string | number | undefined | null;
  component?: React.ReactNode;
  /** The last row in a card carries no separator under it. */
  last?: boolean;
}) => {
  return (
    <>
      <Div $p={last ? '16px 0 0 0' : '16px 0'}>
        <Disclaimer $mb="4">{k}</Disclaimer>
        {component ? component : <H5 $mb="0">{v}</H5>}
      </Div>
      {!last && <Separator />}
    </>
  );
};
